import { DEBUG_NAMESPACE, useDebug } from '@/composables/useDebug';
import { useTranscriptionStore } from '../store/useTranscriptionStore';
import { useTranslationStore } from '../store/useTranslationStore';

const { debug } = useDebug(DEBUG_NAMESPACE.STORE_TRANSLATION);

// The two points where the transcript meets the displayed translation. They live
// here rather than in the transcription store so the two stores do not have to
// import each other.
export const useTranscriptContent = () => {
  // The transcript tab loads lazily, so a load that lands while a translation is
  // displayed must show the translated segments.
  const load = async (transcriptionId?: string) => {
    const transcriptionStore = useTranscriptionStore();
    await transcriptionStore.loadTranscription(transcriptionId);

    const translated = useTranslationStore().activeTranscription;
    if (translated) {
      transcriptionStore.$patch({ transcription: { data: translated.map(segment => ({ ...segment })) } });
    }
  };

  const saveEdits = async () => {
    const transcriptionStore = useTranscriptionStore();
    const translationStore = useTranslationStore();

    if (!translationStore.isTranslationActive) {
      return transcriptionStore.lineSaveAll();
    }

    try {
      await translationStore.updateContent({ transcription: transcriptionStore.editedSegments });
    } catch (e) {
      debug('Cannot update translated transcription', e);
    }
  };

  return { load, saveEdits };
};
